var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-top: 0px;\n  padding-bottom: 8px;\n  min-height: ', ';\n  width: ', ';\n  color: ', ';\n  font-size: ', ';\n  &:last-of-type {\n    padding-bottom: 18px;\n  }\n  .danger {\n    margin-left: 24px;\n    margin-right: 24px;\n    text-align: center;\n  }\n  @media (max-width: 400px) {\n    padding-bottom: 12px;\n  }\n'], ['\n  padding-top: 0px;\n  padding-bottom: 8px;\n  min-height: ', ';\n  width: ', ';\n  color: ', ';\n  font-size: ', ';\n  &:last-of-type {\n    padding-bottom: 18px;\n  }\n  .danger {\n    margin-left: 24px;\n    margin-right: 24px;\n    text-align: center;\n  }\n  @media (max-width: 400px) {\n    padding-bottom: 12px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Section = styled.section(_templateObject, function (props) {
  return props.errors ? '70px' : '0px';
}, function (props) {
  return props.errors ? '340px' : '100%';
}, function (props) {
  return props.errors ? 'red' : '#1a202c';
}, function (props) {
  return props.errors ? '14px' : '16px';
});

var QQSection = function QQSection(props) {
  return React.createElement(Section, {
    errors: props.errors
  }, props.children);
};

export default QQSection;